import React, { useState } from 'react';
import s from './PostedVideo.module.scss';
import { ReactComponent as HearIcon } from 'images/new-icons/services/like.svg';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { supabase } from 'sdk/api';

interface PostedVideoProps {
  salonId?: string;
  categoryId?: string;
}

const PostedVideo: React.FC<PostedVideoProps> = ({ salonId, categoryId }) => {
  const navigate = useNavigate();
  const [hoveredVideoId, setHoveredVideoId] = useState<string | null>(null);

  const { data: posts } = useQuery<any[]>({
    queryKey: ['salonPosts', salonId, categoryId],
    queryFn: async () => {
      let selectString = `
          *,
          salons_profile(*),
          video_categories (id)
      `;

      if (categoryId && categoryId !== 'all') {
        selectString = `
          *,
          salons_profile(*),
          video_categories!inner (id)
        `;
      }

      let query = supabase
        .from('posts')
        .select(selectString)
        .eq('salon_profile', salonId);

      if (categoryId && categoryId !== 'all') {
        query = query.eq('video_categories.id', categoryId);
      }

      const { data, error } = await query.order('created_at', { ascending: false });

      if (error) throw error;
      return data || [];
    },
    enabled: Boolean(salonId),
  });

  if (!salonId || !posts?.length) {
    return null;
  }

  return (
    <div className={s.grid}>
      {posts?.map(post => (
        <div
          key={post.id}
          className={s.card}
          onClick={() => {
            navigate(`/feed/${post.id}`, {
              state: { fromCard: true },
            });
          }}
          onMouseEnter={() => setHoveredVideoId(post.id)}
          onMouseLeave={() => setHoveredVideoId(null)}
        >
          <div className={s.card_image}>
            <video
              src={post.video_link}
              className={s.card_image_video}
              loop
              muted
              playsInline
              autoPlay={hoveredVideoId === post.id}
              onMouseEnter={e => {
                e.currentTarget.play();
              }}
              onMouseLeave={e => {
                e.currentTarget.pause();
                e.currentTarget.currentTime = 0;
              }}
            />
            <div className={s.card_overlay}>
              <HearIcon />
            </div>
          </div>
          <div className={s.card_content}>
            <div className={s.username}>@{post.salons_profile?.name}</div>
            <div className={s.text}>{post.description}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PostedVideo;
